var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_Truck_3961765") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ALLE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Truck_3961765",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5600003,14.8550003 L59.4190003,14.8550003 L59.4190003,0 L7.42700027,0 C5.45707476,0 3.56767989,0.781784411 2.17473215,2.17473215 C0.781784411,3.56767989 0,5.45707476 0,7.42700027 L0,48.2770003 L7.42700027,48.2770003 C7.42700027,54.4300047 12.4149959,59.4180003 18.5680003,59.4180003 C24.7210047,59.4180003 29.7090003,54.4300047 29.7090003,48.2770003 L51.9910003,48.2770003 C51.9910003,54.4300047 56.9789959,59.4180003 63.1320003,59.4180003 C69.2850047,59.4180003 74.2730003,54.4300047 74.2730003,48.2770003 L81.7000003,48.2770003 L81.7000003,29.7090003 L70.5600003,14.8550003 Z M18.5680003,53.8480047 C15.4917742,53.8480047 12.9980003,51.3542263 12.9980003,48.2780003 C12.9980003,45.2017742 15.4917742,42.7080003 18.5680003,42.7080003 C21.6442263,42.7080003 24.1380047,45.2017742 24.1380047,48.2780003 C24.139861,49.7558258 23.553621,51.1736584 22.5086397,52.2186397 C21.4636584,53.263621 20.0458258,53.849861 18.5680003,53.8480047 Z M68.7000003,20.4250003 L76.0000003,29.7090003 L59.4190003,29.7090003 L59.4190003,20.4250003 L68.7000003,20.4250003 Z M63.1300003,53.8480025 C60.0537742,53.8480025 57.5600003,51.3542263 57.5600003,48.2780003 C57.5600003,45.2017742 60.0537742,42.7080003 63.1300003,42.7080003 C66.2062263,42.7080003 68.7000047,45.2017742 68.7000047,48.2780003 C68.70186,49.7554788 68.1158943,51.1730076 67.071346,52.2179311 C66.0267977,53.2628547 64.6094794,53.8493294 63.1320003,53.8480025 L63.1300003,53.8480025 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.3f3fe742ae32f7fe7fca4343caa94813.svg";
export { ForwardRef as ReactComponent };